var map = {
	"./cancel.png": "Qj12",
	"./error.png": "zhDj",
	"./pending.png": "0XFr",
	"./running.png": "KIOQ",
	"./success.png": "XcmK",
	"./waiting.png": "2pmK"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "WimY";


//////////////////
// WEBPACK FOOTER
// ./src/assets/log ^\.\/.*\.png$
// module id = WimY
// module chunks = 46